import { ComboBox } from "@progress/kendo-react-dropdowns";

export const SelectionModeProperty = {
  propertyName: "SelectionMode",
  propertyDisplay: "Selection Mode",
  propertyType: "string",
  propertyCategory: "Validation",
  renderer: function ({ handlePropertyChange, currentPropertyValues }) {
    return (
      <ComboBox
        name={"SelectionMode"}
        data={["single", "multiple"]}
        onChange={(e) => {
          handlePropertyChange({ propName: this.propertyName, propValue: e.target.value });
        }}
        value={currentPropertyValues?.[this.propertyName] || "single"}
      />
    );
  },
};
